/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 04:02 pm
 * Last Modified: Thursday, 25-07-03 10:15 am, by Ben Zhao
 */

import { ReactElement, useCallback, useState } from 'react';
import { ButtonProps } from '@mui/material/Button';
import { Flex } from '@/containers';
import { MessageProps } from '@/message/@type';
import { StyledButton as Button, StyledContent, StyledDialog, StyledFlex, StyledTitle } from './style';
interface StatusDialogButtonProps extends ButtonProps {
  label: string;
}
export interface StatusDialogProps extends MessageProps {
  header: string;
  content: string | ReactElement;
  btn1?: StatusDialogButtonProps;
  btn2?: StatusDialogButtonProps;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  width?: string;
}
export default function StatusDialog(props: StatusDialogProps) {
  const {
    header,
    content,
    btn1,
    btn2,
    flexDirection,
    ...dialogProps
  } = props;
  const [btn1Loading, setBtn1Loading] = useState(false);
  const [btn2Loading, setBtn2Loading] = useState(false);
  const onBtn1Click = useCallback<Required<ButtonProps>['onClick']>(async e => {
    if (!btn1?.onClick || btn1Loading) {
      return;
    }
    try {
      setBtn1Loading(true);
      await btn1.onClick(e);
    } catch (err) {
      console.error('btn1 click err', (err as Error)?.message);
      throw new Error((err as Error)?.message);
    } finally {
      setBtn1Loading(false);
    }
  }, [btn1?.onClick, btn1Loading]);
  const onBtn2Click = useCallback<Required<ButtonProps>['onClick']>(async e => {
    if (!btn2?.onClick || btn2Loading) {
      return;
    }
    try {
      setBtn2Loading(true);
      await btn2.onClick(e);
    } catch (err) {
      console.error('btn2 click err', (err as Error)?.message);
      throw new Error((err as Error)?.message);
    } finally {
      setBtn2Loading(false);
    }
  }, [btn2?.onClick, btn2Loading]);
  return <StyledDialog {...dialogProps} open={dialogProps.open || false} data-sentry-element="StyledDialog" data-sentry-component="StatusDialog" data-sentry-source-file="index.tsx">
      <StyledFlex gap={'24px'} data-sentry-element="StyledFlex" data-sentry-source-file="index.tsx">
        <StyledFlex gap={'8px'} data-sentry-element="StyledFlex" data-sentry-source-file="index.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="index.tsx">{header}</StyledTitle>
          <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="index.tsx">{content}</StyledContent>
        </StyledFlex>

        <Flex flexDirection={flexDirection ?? 'row'} gap={'16px'} width={'100%'} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          {btn1?.label && <Button sx={{
          minWidth: 'fit-content'
        }} disabled={btn1Loading} size="medium" onClick={onBtn1Click} color={btn2 ? 'secondary' : 'primary'}>
              {btn1.label}
            </Button>}
          {btn2 && <Button sx={{
          minWidth: 'fit-content'
        }} disabled={btn2Loading} onClick={onBtn2Click} variant="contained" size="medium">
              {btn2.label}
            </Button>}
        </Flex>
      </StyledFlex>
    </StyledDialog>;
}